import {
  CASES_CHANGE_FILTER_DATES, CASES_CHANGE_FILTER_FULLTEXT_SEARCH, CASES_CHANGE_FILTER_STATUSES, CASES_CHANGE_FILTER_SERVICES,
  CASES_RESET_PAGE, CASES_START_LOADER, CASES_STOP_LOADER, CASES_RECEIVE, CASES_CHANGE_FILTER_SPECIALISTS
} from './available';

export default {
  [CASES_CHANGE_FILTER_DATES] (state, {createdFrom, createdTo}) {
    state.cases.filters.createdFrom = createdFrom
    state.cases.filters.createdTo = createdTo
  },
  [CASES_CHANGE_FILTER_FULLTEXT_SEARCH] (state, fulltextSearchString) {
    state.cases.filters.fulltextSearchString = fulltextSearchString
  },
  [CASES_CHANGE_FILTER_STATUSES] (state, statuses) {
    state.cases.filters.statuses = statuses
  },
  [CASES_CHANGE_FILTER_SERVICES] (state, serviceIds) {
    state.cases.filters.serviceIds = serviceIds
  },
  [CASES_CHANGE_FILTER_SPECIALISTS] (state, specialistIds) {
    state.cases.filters.specialistIds = specialistIds
  },
  [CASES_RESET_PAGE] (state) {
    state.cases.pagination.page = 1
  },
  [CASES_RECEIVE] (state, {cases, casesTotal}) {
    state.cases.items = cases
    state.cases.totalItems = casesTotal
  },
  [CASES_START_LOADER] (state) {
    state.cases.loading = true
  },
  [CASES_STOP_LOADER] (state) {
    state.cases.loading = false
  }

}
